export default "__VITE_ASSET__LowxVElo__"